<ion-content class="maintenance-content" [fullscreen]="true" scrollY="false">
  <div class="maintenance-wrapper">
    <div class="maintenance-card">
      <div class="maintenance-icon">
        <img
          src="assets/icon/maintenance/repairing-service.svg"
          alt="Manutenção"
          onerror="this.style.display='none'"
        />
      </div>

      <h1 class="maintenance-title">Voltamos em breve!</h1>

      <p class="maintenance-message">{{ message() }}</p>

      @if (hasCountdown()) {
        <div class="maintenance-countdown">
          <span class="maintenance-countdown__label">Tempo estimado</span>
          <span class="maintenance-countdown__time">{{ timeLeft() }}</span>
        </div>
      }

      <div class="maintenance-hint">
        <ion-spinner name="dots"></ion-spinner>
        <span>Esta página atualiza sozinha — você volta automaticamente quando terminar.</span>
      </div>
    </div>
  </div>
</ion-content>
